<script>
export default {
  props: {
    value: Boolean,
    module: Object,
  },
  computed: {
    agencyHref() {
      return `/tourclient/dictionary/#/dictionary/partner/edit/${this.module?.partner?.value}`;
    },
    settingShow() {
      return this.module.permission.hasAny(1, 4, 8, 9, 46, 52, 113, 124, 166, 167);
    },
  },
  methods: {
    handlerLogout() {
      this.module.logout()
        .then(() => {
          window.location.href = '/tourclient/login/';
        });
    },
  },
};
</script>
<template>
  <v-menu
    :value="value"
    @input="$emit('input', $event)"
    left
    bottom
    offset-y
    :close-on-click="true"
    max-height="80vh"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
        color="rgba(0, 0, 0, 0.54)"
      >
        <v-icon class="mr-3">mdi-account</v-icon>
        {{module.label}}
        <v-icon
          v-text="'mdi-chevron-down'"
        ></v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item>
        <v-list-item-action>
          <v-icon
            v-text="'mdi-account-circle'"
          ></v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{module.user | label}}</v-list-item-title>
          <v-list-item-subtitle>Логин: {{module.login}}</v-list-item-subtitle>
          <v-list-item-subtitle>{{module.department | label}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :href="agencyHref"
      >
        <v-list-item-action>
          <v-icon>mdi-sitemap</v-icon>
        </v-list-item-action>
        <v-list-item-title>Моё агентство</v-list-item-title>
      </v-list-item>
      <v-list-item
        href="/tourclient/admin/admin/"
        v-if="false"
      >
        <v-list-item-action>
          <v-icon>mdi-cog</v-icon>
        </v-list-item-action>
        <v-list-item-title>Настройки</v-list-item-title>
      </v-list-item>
      <v-list-item
        @click="handlerLogout"
      >
        <v-list-item-action>
          <v-icon>mdi-exit-to-app</v-icon>
        </v-list-item-action>
        <v-list-item-title>Выйти</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
